import { create } from "zustand";

import { EToySessionState } from "@api/toys";

import { EProviderName } from "@configs/toys";

export type TToysStore = {
	sessionId: string | null;
	setSessionId: (sessionId: string | null) => void;
	sessionState: EToySessionState;
	setSessionState: (state: EToySessionState) => void;
	isOpenControlProposalPopUp: boolean;
	setIsOpenControlProposalPopUp: (isOpen: boolean) => void;
	isOpenToyContainer: boolean;
	setIsOpenToyContainer: (isOpen: boolean) => void;
	isToyContainerExpanded: boolean;
	setIsToyContainerExpanded: (isExpanded: boolean) => void;
	isToyContainerDisabled: boolean;
	setIsToyContainerDisabled: (isDisabled: boolean) => void;
	isToysSessionInitialized: boolean;
	shouldLoadToysSession: boolean;
	activePrivateShowId: string | null;
	triggerToysSession: (privateShowId: string) => void;
	completeToysSession: () => void;
	resetToysSessionTrigger: () => void;
	resetToysSession: () => void;
	providerName: EProviderName;
	setProviderName: (name: EProviderName) => void;
	isDeviceOnline: boolean;
	setIsDeviceOnline: (isOnline: boolean) => void;
};

export const useToysStore = create<TToysStore>()((set, _, store) => ({
	sessionId: null,
	setSessionId: (sessionId) => set({ sessionId }),
	sessionState: EToySessionState.IDLE,
	setSessionState: (state) => set({ sessionState: state }),
	isOpenControlProposalPopUp: false,
	setIsOpenControlProposalPopUp: (isOpen) => set({ isOpenControlProposalPopUp: isOpen }),
	isOpenToyContainer: false,
	setIsOpenToyContainer: (isOpen) => set({ isOpenToyContainer: isOpen, isToyContainerExpanded: isOpen }),
	isToyContainerExpanded: false,
	setIsToyContainerExpanded: (isExpanded) => set({ isToyContainerExpanded: isExpanded }),
	isToyContainerDisabled: true,
	setIsToyContainerDisabled: (isDisabled) => set({ isToyContainerDisabled: isDisabled }),
	isToysSessionInitialized: false,
	shouldLoadToysSession: false,
	activePrivateShowId: null,
	triggerToysSession: (privateShowId) =>
		set((state) => {
			if (state.activePrivateShowId === privateShowId) {
				return state.isToysSessionInitialized ? state : { shouldLoadToysSession: true };
			}

			return {
				activePrivateShowId: privateShowId,
				sessionId: null,
				isToysSessionInitialized: false,
				shouldLoadToysSession: true,
			};
		}),
	completeToysSession: () => set({ isToysSessionInitialized: true, shouldLoadToysSession: false }),
	resetToysSessionTrigger: () => set({ shouldLoadToysSession: false }),
	resetToysSession: () => set(store.getInitialState(), true),
	providerName: EProviderName.HANDY,
	setProviderName: (name) => set({ providerName: name }),
	isDeviceOnline: false,
	setIsDeviceOnline: (isOnline) => set({ isDeviceOnline: isOnline }),
}));
